import { createRouter, createWebHistory } from 'vue-router';
import { useAppStore } from '@/store';
import { FEATURE_FLAGS } from '@/constants';

import faq from '@/views/faq.vue';
import about from '@/views/about.vue';
import contact from '@/views/contact.vue';
import aboutAdvertisement from '@/views/aboutAdvertisement.vue';
import policy from '@/views/policy.vue';
import privacy from '@/views/privacy.vue';
import deleteAccount from '@/views/deleteAccount.vue';
import comment from '@/views/comment.vue';
import adAccount from '@/views/adAccount.vue';
import clientChat from '@/views/clientChat.vue';
import adminChat from '@/views/adminChat.vue';
import paymentStatus from '@/views/paymentStatus.vue';

// PUBLICATIONS
import publicationHome from '@/views/publication/publicationHome.vue';
import publications from '@/views/publication/publications.vue';
import publicationDetail from '@/views/publication/publicationDetail.vue';
import publicationCategories from '@/views/publication/publicationCategories.vue';
import publicationSearch from '@/views/publication/publicationSearch.vue';

// MEDIA
import mediaHome from '@/views/media/mediaHome.vue';
import mediaDetail from '@/views/media/mediaDetail.vue';
import medias from '@/views/media/medias.vue';
import news from '@/views/media/news.vue';
import newsDetail from '@/views/media/newsDetail.vue';
import businessAccounts from '@/views/media/businessAccounts.vue';
import businessAccountsDetail from '@/views/media/businessAccountsDetail.vue';
import mediaCategories from '@/views/media/mediaCategories.vue';
import newsSearch from '@/views/media/newsSearch.vue';

// MALL
import mallHome from '@/views/mall/mallHome.vue';
import storeDetail from '@/views/mall/storeDetail.vue';
import storeProductDetail from '@/views/mall/storeProductDetail.vue';
import products from '@/views/mall/products.vue';
import stores from '@/views/mall/stores.vue';
import brands from '@/views/mall/brands.vue';
import brandProducts from '@/views/mall/brandProducts.vue';
import cart from '@/views/mall/cart.vue';
import checkout from '@/views/mall/checkout.vue';
import mallCategories from '@/views/mall/mallCategories.vue';
import productSearch from '@/views/mall/productSearch.vue';

// FOOD
import foodCategories from '@/views/food/foodCategories.vue';
import foods from '@/views/food/foods.vue';
import foodCheckout from '@/views/food/foodCheckout.vue';
import foodCart from '@/views/food/foodCart.vue';
import foodRestaurants from '@/views/food/foodRestaurants.vue';
import foodRestaurantProductDetail from '@/views/food/foodRestaurantProductDetail.vue';
import foodRestaurantDetail from '@/views/food/foodRestaurantDetail.vue';
import foodSearch from '@/views/food/foodSearch.vue';
import foodHomePage from '@/views/food/foodHomePage.vue';

// PROFILE
import profileHome from '@/views/profile/profileHome.vue';
import addresses from '@/views/profile/addresses.vue';
import publicationLiked from '@/views/profile/publicationLiked.vue';
import mediaLiked from '@/views/profile/mediaLiked.vue';
import newsLiked from '@/views/profile/newsLiked.vue';
import mallLiked from '@/views/profile/mallLiked.vue';
import foodLiked from '@/views/profile/foodLiked.vue';
import businessLiked from '@/views/profile/businessLiked.vue';
import selectBusinessAccount from '@/views/profile/selectBusinessAccount.vue';

import myPublications from '@/views/profile/myPublications.vue';
import publicationRequests from '@/views/profile/publicationRequests.vue';
import selectCategory from '@/views/profile/selectCategory.vue';
import addPublication from '@/views/profile/addPublication.vue';
import mallOrders from '@/views/profile/mallOrders.vue';
import foodOrders from '@/views/profile/foodOrders.vue';
import payments from '@/views/profile/payments.vue';
import comments from '@/views/profile/comments.vue';
import viewMyPublication from '@/views/profile/viewMyPublication.vue';
import viewMyPublicationRequest from '@/views/profile/viewMyPublicationRequest.vue';
import editMyPublication from '@/views/profile/editMyPublication.vue';

// BUSINESS
import complaints from '@/views/businessProfile/complaints.vue';
import myBusinessAccounts from '@/views/businessProfile/myBusinessAccounts.vue';
import myBusinessAccountsRequests from '@/views/businessProfile/myBusinessAccountsRequests.vue';
import viewMyBusinessAccount from '@/views/businessProfile/viewMyBusinessAccount.vue';
import updateMyBusinessAccount from '@/views/businessProfile/updateMyBusinessAccount.vue';
import myBusinessPublications from '@/views/businessProfile/myBusinessPublications.vue';
import businessPublicationRequests from '@/views/businessProfile/businessPublicationRequests.vue';
import addBusinessPublication from '@/views/businessProfile/addBusinessPublication.vue';
import viewMyBusinessPublication from '@/views/businessProfile/viewMyBusinessPublication.vue';
import viewMyBusinessPublicationRequest from '@/views/businessProfile/viewMyBusinessPublicationRequest.vue';
import editMyBusinessPublication from '@/views/businessProfile/editMyBusinessPublication.vue';
import viewMyBusinessAccountRequest from '@/views/businessProfile/viewMyBusinessAccountRequest.vue';

const routes = [
  // PUBLICATIONS
  {
    path: '/',
    name: 'publicationHome',
    component: publicationHome,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/publications',
    name: 'publications',
    component: publications,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/publications/categories',
    name: 'publicationCategories',
    component: publicationCategories,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/publication/detail/:id',
    name: 'publicationDetail',
    component: publicationDetail,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/publication/search',
    name: 'publicationSearch',
    component: publicationSearch,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },

  {
    path: '/ad/:id',
    name: 'adAccount',
    component: adAccount,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },

  {
    path: '/faq',
    name: 'faq',
    component: faq,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/about',
    name: 'about',
    component: about,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/aboutAdvertisement',
    name: 'aboutAdvertisement',
    component: aboutAdvertisement,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/comment',
    name: 'comment',
    component: comment,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/policy',
    name: 'policy',
    component: policy,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },
  {
    path: '/delete-account',
    name: 'deleteAccount',
    component: deleteAccount,
    meta: {
      requiresAuth: false,
      layout: 'publication-layout',
    },
  },

  // RESTAURANTS
  {
    path: '/food',
    name: 'foodHomePage',
    component: foodHomePage,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/foods',
    name: 'foods',
    component: foods,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/categories',
    name: 'foodCategories',
    component: foodCategories,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/restaurant/product/detail/:id',
    name: 'foodRestaurantProductDetail',
    component: foodRestaurantProductDetail,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/restaurant/detail/:id',
    name: 'foodRestaurantDetail',
    component: foodRestaurantDetail,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/restaurants',
    name: 'foodRestaurants',
    component: foodRestaurants,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/cart',
    name: 'foodCart',
    component: foodCart,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/checkout/:id',
    name: 'foodCheckout',
    component: foodCheckout,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  {
    path: '/food/search',
    name: 'foodSearch',
    component: foodSearch,
    meta: {
      requiresAuth: false,
      layout: 'food-layout',
    },
  },
  // MEDIA
  {
    path: '/media-content',
    name: 'mediaHome',
    component: mediaHome,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
    },
  },
  {
    path: '/media-content/medias',
    name: 'medias',
    component: medias,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
    },
  },
  {
    path: '/media-content/detail/:id',
    name: 'mediaDetail',
    component: mediaDetail,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
    },
  },
  {
    path: '/media-content/categories',
    name: 'mediaCategories',
    component: mediaCategories,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
      habarlarOnly: true,
      habarlarDisabledRedirect: 'medias',
    },
  },
  {
    path: '/news',
    name: 'news',
    component: news,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
      habarlarOnly: true,
      habarlarDisabledRedirect: 'medias',
    },
  },
  {
    path: '/news/detail/:id',
    name: 'newsDetail',
    component: newsDetail,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
      habarlarOnly: true,
      habarlarDisabledRedirect: 'medias',
    },
  },
  {
    path: '/business/accounts',
    name: 'businessAccounts',
    component: businessAccounts,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
    },
  },
  {
    path: '/business/accounts/detail/:id',
    name: 'businessAccountsDetail',
    component: businessAccountsDetail,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
    },
  },
  {
    path: '/news/search',
    name: 'newsSearch',
    component: newsSearch,
    meta: {
      requiresAuth: false,
      layout: 'media-layout',
      habarlarOnly: true,
      habarlarDisabledRedirect: 'medias',
    },
  },

  // Mall
  {
    path: '/mall',
    name: 'mallHome',
    component: mallHome,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/store/detail/:id',
    name: 'storeDetail',
    component: storeDetail,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/products/',
    name: 'products',
    component: products,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/stores/',
    name: 'stores',
    component: stores,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/categories',
    name: 'mallCategories',
    component: mallCategories,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },

  {
    path: '/mall/store/product/detail/:id',
    name: 'storeProductDetail',
    component: storeProductDetail,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },

  {
    path: '/mall/brands',
    name: 'brands',
    component: brands,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/brand/:id/products',
    name: 'brandProducts',
    component: brandProducts,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/cart',
    name: 'cart',
    component: cart,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/checkout/:id',
    name: 'checkout',
    component: checkout,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },
  {
    path: '/mall/search',
    name: 'productSearch',
    component: productSearch,
    meta: {
      requiresAuth: false,
      layout: 'mall-layout',
    },
  },

  // PROFILE
  {
    path: '/profile/me',
    name: 'profileHome',
    component: profileHome,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/addresses',
    name: 'addresses',
    component: addresses,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/liked/publications',
    name: 'publicationLiked',
    component: publicationLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/liked/mall',
    name: 'mallLiked',
    component: mallLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/liked/media',
    name: 'mediaLiked',
    component: mediaLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/liked/news',
    name: 'newsLiked',
    component: newsLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
      habarlarOnly: true,
      habarlarDisabledRedirect: 'mediaLiked',
    },
  },
  {
    path: '/profile/liked/foods',
    name: 'foodLiked',
    component: foodLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/liked/business',
    name: 'businessLiked',
    component: businessLiked,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/select-business-account',
    name: 'selectBusinessAccount',
    component: selectBusinessAccount,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/select-category',
    name: 'selectCategory',
    component: selectCategory,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/view-publication/:id',
    name: 'viewMyPublication',
    component: viewMyPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/view-publication-request/:id',
    name: 'viewMyPublicationRequest',
    component: viewMyPublicationRequest,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/add-publication/:id',
    name: 'addPublication',
    component: addPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/edit-publication/:id',
    name: 'editMyPublication',
    component: editMyPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/myPublications',
    name: 'myPublications',
    component: myPublications,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },

  {
    path: '/profile/publicationRequests',
    name: 'publicationRequests',
    component: publicationRequests,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/mallOrders',
    name: 'mallOrders',
    component: mallOrders,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/foodOrders',
    name: 'foodOrders',
    component: foodOrders,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/comments',
    name: 'comments',
    component: comments,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/payments',
    name: 'payments',
    component: payments,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/clientchat',
    name: 'clientChat',
    component: clientChat,
    meta: {
      requiresAuth: true,
      layout: 'empty-layout',
    },
  },
  {
    path: '/adminchat/:id',
    name: 'adminChat',
    component: adminChat,
    meta: {
      requiresAuth: false,
      layout: 'empty-layout',
    },
  },
  {
    path: '/payment-status/:uuid',
    name: 'paymentStatus',
    component: paymentStatus,
    meta: {
      // requiresAuth: true,
      layout: 'publication-layout',
    },
  },
  {
    path: '/profile/complaints',
    name: 'complaints',
    component: complaints,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/my-business-accounts',
    name: 'myBusinessAccounts',
    component: myBusinessAccounts,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/my-business-accounts/requests',
    name: 'myBusinessAccountsRequests',
    component: myBusinessAccountsRequests,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/my-business-account/:id',
    name: 'viewMyBusinessAccount',
    component: viewMyBusinessAccount,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },

  {
    path: '/profile/my-business-account-request/:id',
    name: 'viewMyBusinessAccountRequest',
    component: viewMyBusinessAccountRequest,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },

  {
    path: '/profile/my-business-account/:id/update',
    name: 'updateMyBusinessAccount',
    component: updateMyBusinessAccount,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/myBusinessPublications',
    name: 'myBusinessPublications',
    component: myBusinessPublications,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/add-business-publication/:id',
    name: 'addBusinessPublication',
    component: addBusinessPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/edit-business-publication/:id',
    name: 'editMyBusinessPublication',
    component: editMyBusinessPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/businessPublicationRequests',
    name: 'businessPublicationRequests',
    component: businessPublicationRequests,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/view-business-publication/:id',
    name: 'viewMyBusinessPublication',
    component: viewMyBusinessPublication,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
  {
    path: '/profile/view-business-publication-request/:id',
    name: 'viewMyBusinessPublicationRequest',
    component: viewMyBusinessPublicationRequest,
    meta: {
      requiresAuth: true,
      layout: 'profile-layout',
    },
  },
];
const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

router.beforeEach((to, from, next) => {
  const store = useAppStore();

  if (to.meta.habarlarOnly === true && FEATURE_FLAGS.HABARLAR === false) {
    next({ name: to.meta.habarlarDisabledRedirect || 'medias', replace: true });
    return;
  }
  if (to.meta.requiresAuth === true) {
    if (store.authStatus === true) {
      console.log('Auth route, authenticated');
      next();
      return;
    }
    router.replace({ query: { ...to.query, redirect_url: to.path } });

    store.showLogin();
    return;
  }

  next();
});
export default router;
